export default __webpack_public_path__ + "static/media/austin.7214f1c3.jpg";